<template>
  <div>
    <div class="page-header clear-filter" filter-color="blue">
      <parallax class="page-header-image"
                style="background-image:url('img/header.png')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <div class="hidden-lg-and-up">
            <img alt="" class="n-logo" src="img/running-dinner-white-outline.svg"/>-
          </div>
          <div class="jumbotron information">
            <h1 class="h1-seo">{{ tidspunkt }}</h1>
            <div v-if="status === 'running'">
              <p>
                <a class="btn btn-primary btn-lg"
                   rel="tooltip"
                   title="Gå til tilmeldingssiden"
                   target="_blank"
                   :href="tilmeldingUrl">
                  <ticket class="ticket" title="Start tilmelding nu"/>&nbsp;
                  Start tilmelding
                  &nbsp;<ticket class="ticket" title="Start tilmelding nu"/>
                </a>
              </p>
              <h3>Sidste frist for tilmelding er {{ tilmeldingsfrist }}</h3>
            </div>
            <div v-if="status === 'pre'">
              <p>
                <button class="btn btn-primary btn-lg disabled" disabled="disabled">
                  Tilmelding åbner snart!
                </button>
              </p>
            </div>
            <div v-if="status === 'post'">
              <h3>Arrangementet er slut</h3>
              <p>
                <button class="btn btn-primary btn-lg disabled" disabled="disabled">
                  Tilmelding er lukket
                </button>
              </p>
            </div>
            <div class="hidden-md-and-down">
              <h2 class="title">Arrangeret af</h2>
              <img alt="Borgerforeningen i Gl. Rye" src="img/Borgerforeningen_rundt_logo.svg" style="max-width: 100px;padding-bottom: 20px"/>
              <h1 class="h1-seo">Borgerforeningen i Gl. Rye</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section"
         style="background-image: url('img/bg11.jpg'); background-size: cover; background-position: top center; min-height: 600px;">
      <div class="container text-center">
        <div class="row justify-content-md-center ">
          <div class="col-md-12 col-lg-8">
            <about-section/>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container text-center">
        <h3>Sponsorer</h3>
        <sponsors-section></sponsors-section>
        <div class="space-50 sponsor-us">
          <p>Hvis du eller dit firma vil være sponsor, så kontakt os på <a
              href="mailto:info@runningdinner.nu">info@runningdinner.nu</a></p>
        </div>
      </div>
    </div>

    <carousel-section/>
  </div>
</template>
<script>
import {Parallax} from '@/components';
import Ticket from 'vue-material-design-icons/Ticket'
import CarouselSection from "./components/CarouselSection";
import SponsorsSection from "./components/SponsorsSection";
import AboutSection from "./components/AboutSection";

export default {
  name: 'index',
  bodyClass: 'index-page',
  data() {
    return {}
  },
  computed: {
    tidspunkt: function () {
      return this.$store.state.config.tidspunkt
    },
    tilmeldingsfrist: function () {
      return this.$store.state.config.tilmeldingsfrist
    },
    status: function () {
      return this.$store.state.config.status
    },
    tilmeldingUrl: function () {
      return this.$store.state.config.signupUrl
    }
  },
  components: {
    SponsorsSection,
    CarouselSection,
    AboutSection,
    Parallax, Ticket
  },
};
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid";

.brand {
  h1, h3 {
    color: #0e2e5e;
    text-shadow: 1px 1px 2px #fff;
  }

  h3.beb {
    color: #f4d35e;
  }

}

@include media-breakpoint-up(lg) {
  .hidden-lg-and-up {
    display: none;
  }
}


@include media-breakpoint-down(md) {
  .hidden-md-and-down {
    display: none;
  }
  .n-logo {
    width: 75%;
  }
  h1.h1-seo {
    font-size: 20px;
  }
  .btn-lg {
    font-size: 1.2em;
  }
}

@include media-breakpoint-down(md) {
  .index-page {
    .page-header {
      height: 125vh;

      .container {
        > .content-center {
          top: 50%;
        }
      }

    }
  }
}

.sponsor-us {
  padding-top: 20px;

  a {
    color: blue
  }
}

.information {
  background-color: rgba(230, 230, 230, .6);
}
</style>
